module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'devices'
      }
    }
  }, [_vm._v("Devices")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("View Device")])])])]), _vm._v(" "), _c('section', {
    staticClass: "content device-content"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.deviceLoading),
      expression: "deviceLoading"
    }],
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('el-form', {
    ref: "device",
    attrs: {
      "model": _vm.device,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "md": 24,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "name"
    }
  }, [_vm._v(_vm._s(_vm.device.name))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 24,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Serial",
      "prop": "serial"
    }
  }, [_vm._v(_vm._s(_vm.device.serial))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 24,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "ICC Id",
      "prop": "iccId"
    }
  }, [_vm._v(_vm._s(_vm.device.iccId))])], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Customer",
      "prop": "customer.name"
    }
  }, [_vm._v(_vm._s(_vm.device.customer.name))])], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Channels",
      "prop": "channels"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.device.channels
    }
  }, [_c('template', {
    slot: "empty"
  }, [(!_vm.deviceLoading) ? [_vm._v("No channels")] : [_vm._v("Loading...")]], 2), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Name",
      "prop": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Channel",
      "prop": "channelIndex"
    }
  })], 2)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Content")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.contentLoading && !_vm.content.length),
      expression: "contentLoading && !content.length"
    }]
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.content
    }
  }, [_c('template', {
    slot: "empty"
  }, [(!_vm.contentLoading) ? [_vm._v("No content")] : [_vm._v("Loading...")]], 2), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Created",
      "prop": "created"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var created = ref.row.created;

        return [_vm._v("\n                  " + _vm._s(created.format('YYYY-MM-DD HH:mm:ss')) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Start",
      "prop": "startDateTime"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var startDateTime = ref.row.startDateTime;

        return [_vm._v("\n                  " + _vm._s(startDateTime.format('YYYY-MM-DD HH:mm:ss')) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Channel"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var channelIndex = ref.row.channelIndex;

        return [_vm._v("\n                  " + _vm._s(_vm.channelNames[channelIndex] || ("Index " + channelIndex)) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 'ERROR' && scope.row.errorReason) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": scope.row.errorReason,
            "placement": "top"
          }
        }, [_c('el-tag', {
          attrs: {
            "size": "medium",
            "type": "danger"
          }
        }, [_vm._v(_vm._s(scope.row.status))])], 1) : _c('el-tag', {
          attrs: {
            "size": "medium",
            "type": scope.row.status === 'ERROR' ? 'danger' : scope.row.status === 'COMPLETED' ? 'success' : 'info'
          }
        }, [_vm._v("\n                    " + _vm._s(scope.row.status) + "\n                  ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Type",
      "prop": "type"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Duration"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var duration = ref.row.duration;

        return [_vm._v("\n                  " + _vm._s(duration.format('HH:mm:ss')) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.artifactUrl) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "success",
            "icon": "el-icon-download"
          },
          on: {
            "click": function($event) {
              return _vm.handleContentDownload(scope.row)
            }
          }
        }) : _vm._e()]
      }
    }])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.pagination.pageSize,
      "layout": "prev, pager, next, sizes",
      "total": _vm.pagination.totalCount,
      "page-sizes": _vm.pagination.rowsPerPageItems,
      "current-page": _vm.pagination.pageNum
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-74353be1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/devices/View.vue
// module id = 1163
// module chunks = 2